import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild, inject, DestroyRef } from '@angular/core';
import { Table } from 'primeng/table';
import { SharedService } from 'src/app/services/shared/shared.service';
import { Constants } from 'src/app/models/constants';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { startWith } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { DateTimeService } from 'src/app/services/date-time/date-time.service';
import { LayoutService } from 'src/app/services/layout.service';


@Component({
  selector: 'app-report-table',
  standalone: false,
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss'],
})
export class ReportTableComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() headers: any = [];
  @Input() dataList: any = [];

  @ViewChild('dt') dt: Table | undefined;
  CriteriaParam: string = '';
  fromDateParam: string = '';
  toDateParam: string = '';
  displayReports: boolean;
  reportParams: any;
  recordStatus: string = '';
  invoiceType: string = '';
  lang: string;
  currentData: currentDataDto[] = [];
  initialCurrentData: any[] = [];
  isSorted: boolean = null;
  selectedCountry: string;
  isSidebarLayout: boolean = false;

  constructor(
    private sharedService: SharedService,
    public datepipe: DatePipe,
    private translate: TranslateService,
    private storageService: StorageService,
  private dateTimeService: DateTimeService,
  private layoutService: LayoutService) {
   this.isSidebarLayout = this.layoutService.isSidebar;

  }

  ngOnInit(): void {
    this.selectedCountry = this.storageService.getWithDefaultPassphrase("Country");
    this.translate.onLangChange
      .pipe(
        startWith({ lang: this.translate.currentLang || this.translate.getDefaultLang() } as LangChangeEvent),
        takeUntilDestroyed(this.destroyRef))
      .subscribe((event: LangChangeEvent) => {
        this.lang = event.lang;
        this.getReportScreenData();
      });
  }

  ngOnChanges(): void {
    this.getReportScreenData();
  }

  getReportScreenData() {
    this.currentData = [];
    this.initialCurrentData = [];
    this.isSorted = null;
    if (this.dataList) {
      this.currentData = this.dataList.map(element => new currentDataDto(
        element.createdBy,
        element.createdDate,
        element.reportCategory,
        element.reportType,
        this.getReportType(element.reportType, element.reportCategory),
        element.requestId,
        element.status,
        false)
      );
    }

    if (this.currentData && this.currentData.length > 0) {
      const translationKeys = [
        'text.invMgmt',
        'text.dashboard',
        'text.fetchData',
        'text.prntpdf',
        'text.rprt',
        'text.xml',
        'text.generated',
        'text.inprogress',
        'text.failed',
        'text.submitted',
        'text.receipts',
        'text.gtescon',
        'text.invMgmtEinvice',
        "text.reportXLSX",
        "text.reportCSV",
        'text.dataImport',
        "text.legalFormat",
        'text.tableData',
        'text.GTES_Summary_XML',
        'text.reportsCategoryInward',
        'text.reportsCategoryDataImport',
        'text.reportsCategoryEReport'
      ];
      this.translate.get(translationKeys).subscribe(res => {
        this.currentData.forEach(element => {
          if (element.reportCategory) {
            switch (element.reportCategory) {
              case Constants.invoiceManagement:
                element.reportCategory = this.selectedCountry == 'MY'? res["text.invMgmtEinvice"]:res["text.invMgmt"];
                break;
              case Constants.dashboard:
                element.reportCategory = res["text.dashboard"];
                break;
              case Constants.FETCHDATA:
                element.reportCategory = res["text.fetchData"];
                break;
              case Constants.INWARD:
              case Constants.Inward_Invoices:
                element.reportCategory = res["text.reportsCategoryInward"];
                break;
                case Constants.receipts:
                  element.reportCategory = res["text.receipts"];
                  break;  
              case Constants.consol:
               element.reportCategory = res["text.gtescon"];
              break;
              case Constants.DATAIMPORT:
              case "Data Import":
                element.reportCategory = res["text.reportsCategoryDataImport"];
                break;
              case "EREPORT":
                element.reportCategory = res["text.reportsCategoryEReport"];
                break;
            }
          }
          if (element.reportType) {
            switch (element.reportType) {
              case Constants.printPdf:
                element.reportType = res["text.prntpdf"];
                break;
              case Constants.report:
                element.reportType = res["text.rprt"];
                break;
              case Constants.report_XLSX:
                element.reportType = res["text.reportXLSX"];
                break;
              case Constants.report_CSV:
                element.reportType = res["text.reportCSV"];
                break;
              case Constants.xml:
                element.reportType = res["text.xml"];
                break;
              case "legalFormat":
                element.reportType = res["text.legalFormat"];
                break;
                case Constants.legalFormat:
                element.reportType = res["text.legalFormat"];
                break;
              case Constants.pdf:
                element.reportType = res["text.prntpdf"];
                break;
              case Constants.tableData:
                element.reportType = res["text.tableData"];
                break;
              case "GTES Summary XML":
                element.reportType = res["text.GTES_Summary_XML"];
                break;
            }
          }
          if (element?.status) {
            const statusLowerCase = element.status.toLowerCase();
            switch (statusLowerCase) {
              case Constants.generated.toLowerCase():
              case Constants.GENERATED.toLowerCase():
                element.status = res["text.generated"];
                element.genCheck = true;
                break;
              case Constants.inProgress.toLowerCase():
                element.status = res["text.inprogress"];
                break;
              case Constants.failed.toLowerCase():
                element.status = res["text.failed"];
                break;
              case Constants.submitted.toLowerCase():
                element.status = res["text.submitted"];
                break;
            }
          }
        });
        this.initialCurrentData = [...this.currentData];
      });
    }
  }

  clearTableFilter() {
    this.clearTable(this.dt);
  }

  filterGlobal(value: string, matchMode: string = 'contains'): void {
    this.dt?.filterGlobal(value, matchMode);
  }

  clearTable(table: Table) {
    table.clear();
  }

  gtesStstus = [
  { code: '10', name: 'Success_GTES' },
  { code: '20', name: 'Error_GTES' },
  { code: '30', name: 'Pen_Dup' },
  { code: '40', name: 'Inprogress_PA' },
  { code: '50', name: 'Success_PA' },
  { code: '60', name: 'Error_PA' }
]

private getMappedNameFromCode(mappingList: Array<{ code: string; name: string }>, value: any): string {
  const rawValue = value == null ? '' : String(value).trim();
  if (!rawValue) {
    return rawValue;
  }

  const mapped = mappingList.find(item => item.code === rawValue);
  return mapped ? mapped.name : rawValue;
}

  displayReportParamDetails(requestId) {
    this.sharedService.getReportParamDetails(requestId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.reportParams = JSON.parse(data);
        if (this.reportParams) {
          this.CriteriaParam = this.reportParams.Criteria;
          if (this.CriteriaParam == Constants.dataReceivedDate) {
            this.translate.get('text.dataReceivedDate').subscribe(res => {
              this.CriteriaParam = res;
            });
          } else if (this.CriteriaParam == Constants.documentDate) {
            this.translate.get('text.documentDate').subscribe(res => {
              this.CriteriaParam = res;
            });
          } else if (this.CriteriaParam == Constants.ksefDate) {
            this.translate.get('text.MOFDate').subscribe(res => {
              this.CriteriaParam = res;
            });
          }
          this.fromDateParam = this.selectedCountry === 'MY' ? this.dateTimeService.formatDateFromUTCTolocalDate(this.reportParams.fromDateAndTime, 'YYYY-MM-dd') : this.changeDateFormate(this.reportParams.From_Date);
          this.toDateParam = this.selectedCountry === 'MY' ? this.dateTimeService.formatDateFromUTCTolocalDate(this.reportParams.toDateAndTime, 'YYYY-MM-dd') : this.changeDateFormate(this.reportParams.To_Date);
          this.recordStatus = this.reportParams.recordStatus;
          if(this.selectedCountry == 'FR'){
            const statusCodes = String(this.recordStatus || '')
              .split(',')
              .map(code => code.trim())
              .filter(code => !!code);

            this.recordStatus = statusCodes
              .map(code => this.getMappedNameFromCode(this.gtesStstus, code))
              .join(', ');
            if (this.recordStatus == Constants.all) {
              this.translate.get('text.all').subscribe(res => {
                this.recordStatus = res;
              });
            }  
          }else {
            if (this.recordStatus == Constants.all) {
              this.translate.get('text.all').subscribe(res => {
                this.recordStatus = res;
              });
            } else if (this.recordStatus == Constants.processedEY) {
              this.translate.get('text.psdEY').subscribe(res => {
                this.recordStatus = res;
              });
            } else if (this.recordStatus == Constants.processedMoF) {
              this.translate.get('text.psdMOF').subscribe(res => {
                this.recordStatus = res;
              });
            } else if (this.recordStatus == Constants.errorMoF) {
              this.translate.get('text.errMOF').subscribe(res => {
                this.recordStatus = res;
              });
            } else if (this.recordStatus == Constants.inprogressMof) {
              this.translate.get('text.inprogressMOF').subscribe(res => {
                this.recordStatus = res;
              });
            } else if (this.recordStatus == Constants.errorEY) {
              this.translate.get('text.errEY').subscribe(res => {
                this.recordStatus = res;
              });
            }
          }
          this.invoiceType = this.reportParams.invoiceType;
          if (this.invoiceType == Constants.all || this.invoiceType == 'All') {
            this.translate.get('text.all').subscribe(res => {
              this.invoiceType = res;
            });
          }
        }

        setTimeout(() => {
          this.showReportParamDialog();
        }, 0);

      });
  }

  showReportParamDialog() {
    this.displayReports = true;
  }

  private changeDateFormate(date: string): string {
    return `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(6, 8)}`;
  }

  private getReportType(reportType, reportCategory) {
    let rptType = reportType;
    switch (reportType + "_" + reportCategory) {
      case Constants.report_XLSX + "_Invoice Management":
      case Constants.report_CSV + "_Invoice Management":
      case Constants.report + "_Invoice Management":
        rptType = Constants.report;
        break;

      case Constants.pdf + "_Invoice Management":
        rptType = Constants.pdf;
        break;

      case Constants.xml + "_Invoice Management":
        rptType = Constants.xml;
        break;

      case "GTES to SDI XML_Invoice Management":
        rptType = Constants.OUT_SDI;
        break;

      case "SDI XML_FETCHDATA":
        rptType = Constants.IN_SDI;
        break;

      case "SDI Response XML_Invoice Management":
        rptType = Constants.OUT_RESP_SDI;
        break;

      case Constants.report_XLSX + "_INWARD":
      case Constants.report_CSV + "_INWARD":
      case Constants.report + "_INWARD":
        rptType = "INWARD_" + Constants.report;
        break;

      case Constants.pdf + "_INWARD":
        rptType = "INWARD_" + Constants.pdf;
        break;
      case "Legal Format_INWARD":
        rptType = "INWARD_LEGAL_FORMAT";
        break;
      case "GTES XML_INWARD":
      case Constants.xml + "_INWARD":
        rptType = "INWARD_" + Constants.xml;
        break;
      case Constants.tableData + "_INWARD":
        rptType = "INWARD_" + Constants.tableData;
        break;
      case "XML/JSON from IRBM_INWARD":
        rptType = "INWARD_" + Constants.xml_json;
        break;
      case Constants.tableData + "_RECEIPT":
        rptType = "RECEIPT_" + Constants.tableData;
        break;
      case Constants.report_XLSX + "_RECEIPT":
      case Constants.report_CSV + "_RECEIPT":
      case Constants.report + "_RECEIPT":
        rptType = "RECEIPT_" + Constants.report;
        break;
      case Constants.tableData + "_CONSOL":
        rptType = "CONSOL_" + Constants.tableData;
        break;
      case Constants.report_XLSX + "_CONSOL":
      case Constants.report_CSV + "_CONSOL":
      case Constants.report + "_CONSOL":
        rptType = "CONSOL_" + Constants.report;
        break;
      case Constants.pdf + "_CONSOL":
        rptType = "CONSOL_" + Constants.pdf;
        break;
      case Constants.xml + "_CONSOL":
        rptType = "CONSOL_" + Constants.xml;
        break;
      case Constants.pdf_english + "_Invoice Management":
        rptType = Constants.pdf_english_outward;
        break;
      case Constants.pdf_english + "_INWARD":
        rptType = Constants.pdf_english_inward;
        break;
      case Constants.tableData + "_DATAIMPORT":
        rptType = "TableData_DataImport";
        break;
      case Constants.tableData + "_EREPORT":
        rptType = "TableData_EREPORT";
        break;
      case Constants.report + "_EREPORT":
        rptType = "Report_EREPORT";
        break;
      case Constants.xml + "_EREPORT":
        rptType = "XML_EREPORT";
        break;
    }
    return rptType;
  }

  customSortFunction(event: any) {
    if (this.isSorted == null || this.isSorted === undefined) {
      this.isSorted = true;
      this.sortTableData(event);
    } else if (this.isSorted == true) {
      this.isSorted = false;
      this.sortTableData(event);
    } else if (this.isSorted == false) {
      this.isSorted = null;
      this.currentData = [...this.initialCurrentData];
      this.dt.reset();
    }
  }

  sortTableData(event: any) {
    const field = event.field;
    const order = this.isSorted ? 1 : -1;
    this.currentData.sort((a, b) => {
      const rawA = a[field];
      const rawB = b[field];
      const numA = Number(rawA);
      const numB = Number(rawB);

      if (rawA != null && rawA !== '' && !isNaN(numA) &&
          rawB != null && rawB !== '' && !isNaN(numB)) {
        return (numA - numB) * order;
      }

      const valueA = rawA ? rawA.toString().toLowerCase() : '';
      const valueB = rawB ? rawB.toString().toLowerCase() : '';
      if (valueA < valueB) {
        return -1 * order;
      } else if (valueA > valueB) {
        return 1 * order;
      } else {
        return 0;
      }
    });
  }
}


class currentDataDto {
  createdBy?: string;
  createdDate?: string;
  reportCategory?: string;
  reportType?: string;
  downloadCateg?: string;
  requestId?: string;
  status?: string;
  genCheck?: any;

  constructor(createdBy, createdDate, reportCategory, reportType, downloadCateg, requestId, status, genCheck) {
    this.createdBy = createdBy;
    this.createdDate = createdDate;
    this.reportCategory = reportCategory;
    this.reportType = reportType;
    this.downloadCateg = downloadCateg;
    this.requestId = requestId;
    this.status = status;
    this.genCheck = genCheck;
  }

}
